import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { store } from '../..';
import { jgrowEventService } from '@/service/api/jgrow-event.service';
import { Event, UpdateEventsStudentsResult } from '@/models/jgrow/event';
import { EventProgress, EventProgressResult } from '@/models/jgrow/event-progress';
import FileSaver from 'file-saver';

export interface IJgrowEventProgressState {
  eventProgress: EventProgress[]; // イベント進捗データ
}
@Module({ dynamic: true, store, name: 'jgrowEventProgressModule', namespaced: true })
class JgrowEventProgressModule extends VuexModule implements IJgrowEventProgressState {
  eventProgress: EventProgress[] = [];
  noAssignedExamineeCount: number = 0;
  eventProgressBySchoolGrade: EventProgressBySchoolGrade;

  /**
   * 学年ごとにデータをまとめる
   * 学年以外に「全部」というものも作成する必用あり
   */
  get progressBySchoolGrade(): Map<string, EventProgress[]> {
    const map = new Map<string, EventProgress[]>();
    // 最初に「全てタブ」に表示する全部のデータを設定する
    map.set('全部', this.eventProgress);

    // 学年単位でまとめる
    this.eventProgress.forEach((ep: EventProgress) => {
      const key = String(ep.grade) + '年';
      if (!map.has(key)) {
        map.set(key, []);
      }
      map.get(key).push(ep);
    });
    return map;
  }

  @Mutation
  clean() {
    this.eventProgress = [];
  }

  @Mutation
  setEventProgress(data: EventProgressResult) {
    this.eventProgress = data.userSurveyProgress;
    this.noAssignedExamineeCount = data.noAssignedExamineeCount;
  }

  /**
   * イベント進捗取得
   * @param eventID イベントID
   */
  @Action({ rawError: true })
  async fetchEventProgress(eventID: number) {
    const progress = await jgrowEventService.getProgress(eventID);
    this.setEventProgress(progress);
  }

  /**
   * イベント進捗ダウンロード
   * @param data 受検設定
   */
  @Action({ rawError: true })
  async downloadProgress(event: Event) {
    const file = await jgrowEventService.downloadProgress(event.ID);
    FileSaver.saveAs(file, `${event.eventName}_進捗.xlsx`);
  }

  /**
   * 受検者割り当て情報更新
   * @param evalSettingID
   */
  @Action({ rawError: true })
  updateExamineeStudents(evalSettingID: number): Promise<UpdateEventsStudentsResult> {
    return jgrowEventService.updateExamineeStudents(evalSettingID);
  }
}

export const jgrowEventProgressModule = getModule(JgrowEventProgressModule);

export class EventProgressBySchoolGrade {
  [key: string]: EventProgress[];
}
